import React from 'react'
import { Form, notification } from 'antd'

const openNotification = message => {
  notification.open({
    message: 'Erro',
    description: <ul>{message}</ul>,
    onClick: () => {
      console.log('Notification Clicked!')
    }
  })
}

const ErrorHandlerForm = props => {
  const onFinishFail = errorInfo => {
    const errorMessage = errorInfo.errorFields.reduce((message, next) => {
      const erro = `${next.errors.join('')}`
      message.push(<li>{erro}</li>)
      return message
    }, [])

    openNotification(errorMessage)
  }

  return (
    <Form {...props} onFinishFailed={onFinishFail}>
      {props.children}
    </Form>
  )
}

ErrorHandlerForm.useForm = Form.useForm
ErrorHandlerForm.Item = Form.Item
ErrorHandlerForm.Provider = Form.Provider
ErrorHandlerForm.showErrorMessage = openNotification
export default ErrorHandlerForm
